import { render, staticRenderFns } from "./cookie-notice.vue?vue&type=template&id=44c206a0&scoped=true"
import script from "./cookie-notice.vue?vue&type=script&lang=js"
export * from "./cookie-notice.vue?vue&type=script&lang=js"
import style0 from "./cookie-notice.vue?vue&type=style&index=0&id=44c206a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c206a0",
  null
  
)

export default component.exports